export default __webpack_public_path__ + "static/media/web-app-logo-128@2x.df3718a7.png";